import React from 'react'
import Accordion from '../Accordion/Accordion'
import Team from './Team'

function CustomiseChat() {
    return (
        <div className='w-full mx-auto max-w-2xl'>
            <Accordion title={"Does your order includes customisation? "}>
                <div className="mt-2">
                    <h3 className="text-[clamp(0.9,2vw+1rem,1rem)] text-green-800">Chat one of our team members</h3>

                    {/* Chat Palce  */}
                    <div className="space-y-2 mt-3">
                        <Team name={"Stephen"} number={"+233248168831"} />
                        <Team name={"Fred"} number={"+233242922919"} />
                        <Team name={"Boateng Jnr"} number={"+233503797658"} />
                        <Team name={"Felix"} number={"+233559820445"} />
                    </div>
                </div>
            </Accordion>
        </div>
    )
}

export default CustomiseChat    